import React from 'react';
import styled from 'styled-components';
import Text from 'components/Text';
import { COLOR } from 'config';
import { FormattedHTMLMessage } from 'react-intl';
import image from '../images/Mobile_Wallet_graphic_3.png';
import Title from './Title';
import Card from './Card';
import { ImageGraphicCardContainer } from './ImageCard';

const StyledText = styled(Text)`
  line-height:2.35rem;
`;

const Secure = () => {
  const icon = (<ImageGraphicCardContainer
    image={image}
    width="480"
    backgroundSize="410px"
    backgroundColor={COLOR.base}
    pr="48px"
  />);

  return (
    <Card image={icon} mb={'3rem'} flexDirection="row-reverse">
      <Title id="landing.mobileWallets.secure.title" />
      <StyledText>
        <FormattedHTMLMessage id="landing.mobileWallets.secure.description" />
      </StyledText>
    </Card>
  );
};

export default Secure;



// WEBPACK FOOTER //
// ./src/components/MobileWalletsLanding/components/Secure.js